import { CameraOrientation, RecentCameraImages } from 'types/CarTracking';

export type MockRecentCamerasScenario = 'mixed' | 'aerialOnly' | 'tripwireOnly';

export const mockRecentCamerasByScenario: Record<MockRecentCamerasScenario, RecentCameraImages> = {
    mixed: {
        overhead_images: [
            {
                camera_id: 166,
                name: 'Saks Fifth AirHunter 01',
                image_url: 'https://storage.googleapis.com/yellowstone_8579/1720196945.jpg',
                event_datetime: 1720196945,
            },
            {
                camera_id: 232,
                name: 'Saks Fifth AirHunter 02',
                image_url: 'https://storage.googleapis.com/yellowstone_8579/1720196945.jpg',
                event_datetime: 1720197123,
            },
        ],
        lpr_images: [
            {
                camera_id: 718,
                name: '#065R Tripwire Saks Fifth Roundabout Entry - Reverse',
                image_url:
                    'https://storage.googleapis.com/camera_event/tripwire_b5d1b5b9-117d-4f0b-a7f2-8bfc919c9648.jpeg',
                event_datetime: 1720196702,
                orientation: CameraOrientation.EXIT,
            },
            {
                camera_id: 927,
                name: '#068 Tripwire Saks Fifth Roundabout Exit',
                image_url:
                    'https://storage.googleapis.com/camera_event/tripwire_2df53e23-dee6-44bc-b281-cf85d44d0c93.jpeg',
                event_datetime: 1720197144,
                orientation: CameraOrientation.EXIT,
            },
            {
                camera_id: 748,
                name: '#068R Tripwire Saks Fifth Roundabout Exit - Reverse',
                image_url:
                    'https://storage.googleapis.com/camera_event/tripwire_2c4941dc-2657-410f-99ce-7510681b3d7d.jpeg',
                event_datetime: 1720195658,
                orientation: CameraOrientation.ENTRANCE,
            },
            {
                camera_id: 942,
                name: '#70 Tripwire Saks Fifth Entry',
                image_url:
                    'https://storage.googleapis.com/camera_event/tripwire_ad16ebb3-6583-4d7b-b5fd-9dd9cdf8cfbf.jpeg',
                event_datetime: 1720196556,
                orientation: CameraOrientation.ENTRANCE,
            },
            {
                camera_id: 943,
                name: '#071 Tripwire Saks Fifth Exit',
                image_url:
                    'https://storage.googleapis.com/camera_event/tripwire_773d4268-c409-40c2-8b5a-507e924230d5.jpeg',
                event_datetime: 1720197146,
                orientation: CameraOrientation.EXIT,
            },
            {
                camera_id: 719,
                name: '#065 Tripwire Saks Fifth Roundabout Entry',
                image_url:
                    'https://storage.googleapis.com/camera_event/tripwire_de370eed-3e81-4393-9d73-5e96cae7f8e6.jpeg',
                event_datetime: 1720196681,
                orientation: CameraOrientation.ENTRANCE,
            },
        ],
    },
    aerialOnly: {
        overhead_images: [
            {
                camera_id: 301,
                name: 'City Center Aerial 01',
                image_url: 'https://storage.googleapis.com/yellowstone_8579/1720196945.jpg',
                event_datetime: 1720283345,
            },
            {
                camera_id: 302,
                name: 'City Center Aerial 02',
                image_url: 'https://storage.googleapis.com/yellowstone_8579/1720196945.jpg',
                event_datetime: 1720283523,
            },
            {
                camera_id: 303,
                name: 'City Center Aerial 03',
                image_url: 'https://storage.googleapis.com/yellowstone_8579/1720197400.jpg',
                event_datetime: 1720283800,
            },
        ],
        lpr_images: [],
    },
    tripwireOnly: {
        overhead_images: [],
        lpr_images: [
            {
                camera_id: 901,
                name: 'Main Entrance Tripwire',
                image_url:
                    'https://storage.googleapis.com/camera_event/tripwire_de370eed-3e81-4393-9d73-5e96cae7f8e6.jpeg',
                event_datetime: 1720369821,
                orientation: CameraOrientation.ENTRANCE,
            },
            {
                camera_id: 902,
                name: 'Secondary Entrance Tripwire',
                image_url:
                    'https://storage.googleapis.com/camera_event/tripwire_ad16ebb3-6583-4d7b-b5fd-9dd9cdf8cfbf.jpeg',
                event_datetime: 1720369956,
                orientation: CameraOrientation.ENTRANCE,
            },
            {
                camera_id: 903,
                name: 'Main Exit Tripwire',
                image_url:
                    'https://storage.googleapis.com/camera_event/tripwire_773d4268-c409-40c2-8b5a-507e924230d5.jpeg',
                event_datetime: 1720370146,
                orientation: CameraOrientation.EXIT,
            },
            {
                camera_id: 904,
                name: 'Secondary Exit Tripwire',
                image_url:
                    'https://storage.googleapis.com/camera_event/tripwire_2df53e23-dee6-44bc-b281-cf85d44d0c93.jpeg',
                event_datetime: 1720370344,
                orientation: CameraOrientation.EXIT,
            },
        ],
    },
};

const mockScenarioOrder: MockRecentCamerasScenario[] = ['mixed', 'aerialOnly', 'tripwireOnly'];

function getScenarioIndex(spotUuid: string): number {
    return Array.from(spotUuid).reduce((total, char) => total + char.charCodeAt(0), 0) % mockScenarioOrder.length;
}

export function getMockRecentCameras(spotUuid: string, scenario?: MockRecentCamerasScenario): RecentCameraImages {
    const selectedScenario = scenario ?? mockScenarioOrder[getScenarioIndex(spotUuid || 'camera-view')];
    return mockRecentCamerasByScenario[selectedScenario] ?? mockRecentCamerasByScenario.mixed;
}

export const recentCamerasMock: RecentCameraImages = mockRecentCamerasByScenario.mixed;
